import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  EntityState,
} from "@reduxjs/toolkit";
import { partnersAPI as API, Partner as Item } from "../../apis/partners";
import { RootState } from "../store";

export const loadPartners = createAsyncThunk(
  "partners/load",
  (page: number = 1) => API.fetchPage(page),
  {
    condition: (page, { getState }: any) => {
      const { partners } = getState() as RootState;
      if (partners.status !== "idle") return false;
    },
  }
);

const itemsAdapter = createEntityAdapter<Item>();
interface Partners extends EntityState<Item> {
  status: "idle" | "loading" | "succeeded" | "failed";
}
const initialState: Partners = {
  ...itemsAdapter.getInitialState(),
  status: "idle"
};

const slice = createSlice({
  name: "partners",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadPartners.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loadPartners.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(loadPartners.fulfilled, (state, { payload }) => {
        state.status = "succeeded";
        itemsAdapter.setAll(state, payload.data);
      });
  },
});

export default slice.reducer;
